export default function OfflineBar() {
  return (
    <div className="offline-bar" role="alert">
      <span className="offline-dot" />
      آفلاین — تغییرات ذخیره می‌شود
    </div>
  );
}
